
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/posts",
      function () {
        return require("private-next-pages/users/[id]/posts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/posts"])
      });
    }
  